import(/* webpackMode: "eager" */ "/home/runner/work/papyrus-index/papyrus-index/src/app/not-found.tsx");
